<template>
    <div class="erm_wrapper">

        <AppModal :title="'Add New Menu Item'" :width="700" :showFooter="false" ref="add_menu_modal">
            <template #body>
                <AddMenu  @updateDataAfterNewAdd="updateDataAfterNewAdd"/>
            </template>
        </AppModal>

        <AppTable :tableData="menus" v-loading="loading">
            <template #header>
                <h1 class="table-title">All Menu Item</h1>
                <el-button @click="OpenMenuAddModal()" size="large" type="primary" icon="Plus" class="ltm_button">
                    Add New Menu Item
                </el-button>
            </template>

            <template #filter>
                <el-input class="easyRestaurantManager-search-input erm_input" v-model="search" style="width: 240px" size="large"
                    placeholder="Please Input" prefix-icon="Search" />
            </template>

            <template #columns>
                <el-table-column prop="id" label="ID" width="60" />
                <el-table-column label="Image" width="auto">
                    <template #default="{ row }">
                        <img v-if="row?.image" :src="row?.image" alt="image"
                            style="width: 60px; height: 60px; object-fit: cover;">
                        <span v-else>No Image</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Name" width="auto" />
                <el-table-column prop="base_price" label="Price" width="auto" />
                <el-table-column prop="availability" label="Availability" width="auto" />
                <el-table-column prop="added_date" label="Created Date" width="auto">
                    <template #default="{ row }">
                        {{ formatAddedDate(row.created_at) }}
                    </template>
                </el-table-column>
                <el-table-column label="Operations" width="120">
                    <template #default="{ row }">
                        <el-tooltip class="box-item" effect="dark" content="Click to edit menus" placement="top-start">
                            <el-button  @click="openUpdateMenuModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-edit" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="Click to delete menus"
                            placement="top-start">
                            <el-button @click="openDeleteMenuModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-delete" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </template>

            <template #footer>
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 40]" large :disabled="total_menu <= pageSize" background
                    layout="total, sizes, prev, pager, next" :total="+total_menu" />
            </template>

        </AppTable>

        <AppModal :title="'Update Menu'" :width="800" :showFooter="false" ref="update_menu_modal">
            <template #body>
                <AddMenu :menus_data="menu" />
            </template>
        </AppModal>

        <AppModal :title="'Delete Menu'" :width="500" :showFooter="false" ref="delete_menu_modal">
            <template #body>

                <div class="delete-modal-body">
                    <h1>Are you sure ?</h1>
                    <p>You want to delete this menu</p>
                </div>
            </template>
            <template #footer>
                <div class="easyRestaurantManager-modal-footer">
                    <el-button @click="$refs.delete_menu_modal.handleClose()" type="default"
                        size="medium">Cancel</el-button>
                    <el-button @click="deleteMenu" type="primary" size="medium">Delete</el-button>
                </div>
            </template>
        </AppModal>

    </div>
</template>

<script>
import axios from 'axios';
import AppTable from "../../components/AppTable.vue";
import Icon from "../../components/Icons/AppIcon.vue";
import AppModal from "../../components/AppModal.vue";
import AddMenu from "./AddMenu.vue";
export default {
    components: {
        AppTable,
        Icon,
        AppModal,
        AddMenu
    },
    data() {
        return {
            search: '',
            menus: [],
            menu: {},
            total_menu: 0,
            loading: false,
            add_menu_modal: false,
            currentPage: 1,
            pageSize: 10,
            active_id: null,
            rest_api: window.RestaurantMenuMangeData.rest_api,
            nonce: window.RestaurantMenuMangeData.nonce
        }
    },
    methods: {
        formatAddedDate(date) {
            if (!date) return '';
            const options = { day: 'numeric', month: 'long', year: 'numeric' };
            return new Date(date).toLocaleDateString('en-GB', options);
        },
        OpenMenuAddModal() {
            this.$refs.add_menu_modal.openModel();
        },
        async getMenu() {
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/getMenu`, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                console.log('response', response.data);
                this.menus = response.data?.menus;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching couriers:',);
            }
        },

        openUpdateMenuModal(row) {
            this.menu = row;
            this.$refs.update_menu_modal.openModel();
        },

        openDeleteMenuModal(row) {
            this.active_id = row.id;
            this.$refs.delete_menu_modal.openModel();
        },
        async deleteMenu() {
            try {
                const response = await axios.post(`${this.rest_api}/deleteMenu`, { id: this.active_id }, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                this.getMenu();
                this.$refs.delete_menu_modal.handleClose();
            } catch (error) {
                console.error('Error fetching couriers:',);
            }
        },

        updateDataAfterNewAdd(new_menu) {
            this.$refs.add_menu_modal.handleClose();
            this.menus.unshift(new_menu);
        },
    },
    mounted() {

        this.getMenu();

    }


}
</script>